import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, FormGroup, Input, Button } from 'reactstrap';
import AuthApi from '../../services/Auth';

import logo from '../../assets/images/Kronos.svg';
import './Login.css';

const LoginForgot = () => {
    const { t } = useTranslation();
    const [email, setEmail]       = useState('');
    const [loading, setLoading]   = useState(false);
    const [message, setMessage]   = useState('');
    const [error, setError]       = useState('');

    const submit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMessage('');
        AuthApi.forgotPassword(email)
            .then((success) => {
                setMessage(typeof success === 'string' ? success : t('login.forgot_password_success'));
            })
            .catch((err) => {
                setError(err.message || t('login.generic_error'));
            })
            .finally(() => setLoading(false));
    };

    return (
        <Form onSubmit={submit} className="LoginForm appear">
            <img className="logo" src={logo} alt="logo" />
            <h2 className="h4 mb-3">{t('login.forgot_password_title')}</h2>
            <FormGroup>
                <Input
                    required
                    type="email"
                    autoComplete="email"
                    name="email"
                    id="forgot-email"
                    placeholder={t('login.email')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
            </FormGroup>
            <Button type="submit" className="btn btn-lg btn-block btn-dark" disabled={loading}>
                {loading ? <i className="fa fa-spinner fa-spin" aria-hidden="true" /> : t('login.send_reset_link')}
            </Button>
            {message && (
                <div className="alert alert-success mt-3" role="status">
                    {message}
                </div>
            )}
            {error && (
                <div className="alert alert-danger mt-3" role="alert">
                    {error}
                </div>
            )}
            <p className="mt-3">
                <Link to="/login">{t('login.back_to_login')}</Link>
            </p>
        </Form>
    );
};

export default LoginForgot;
